export enum CompanyInformationView {
  General, Notifications, SignupRegister, AzureActiveDirectory, ApiKeys, VisitorCheckin, Other, DangerZone, WhereaboutsVisibility, AutomatedReporting
}
